module.exports = __webpack_public_path__ + "assets/img/5ea97e6732bea11ff89f89922a9cc54e.svg";